import styled from 'styled-components';

import { themeGet } from '../../theme';

export const LoadingBar = styled.div.attrs({ 'data-testid': 'loading-bar' })<{ progress: number }>`
  position: fixed;
  top: 0px;
  z-index: ${themeGet.zIndex('MODAL', 9)};
  width: 100%;
  height: 3px;
  background-color: ${themeGet.colors('potPourri')};
  transition: opacity 200ms linear 300ms;
  opacity: ${({ progress }) => (progress === 0 || progress === 100 ? '0' : '1')};
  &::before {
    display: block;
    content: ' ';
    transition: ${themeGet.transition('width', 'fast')};
    width: ${({ progress }) => `${progress}%`};
    height: 3px;
    background-color: ${themeGet.colors('primary')};
  }
`;
